/**
 * Types and constants for ImageDirectorChat
 */

// ── Interfaces ────────────────────────────────

export interface ChatMessage {
  role: "user" | "assistant";
  content: string;
  imageUrl?: string;
}

export type { ChatReferenceImage } from "@/lib/types/media";

// ── Type Aliases ──────────────────────────────

export const RESOLUTION_OPTIONS = ["standard", "2k", "4k"] as const;
export type Resolution = (typeof RESOLUTION_OPTIONS)[number];

export const ASPECT_RATIO_OPTIONS = ["1:1", "4:5", "9:16", "16:9", "3:2"] as const;
export type AspectRatio = (typeof ASPECT_RATIO_OPTIONS)[number];

// ── Constants ─────────────────────────────────

export { MAX_REFERENCE_IMAGES } from "@/config/constants";
export const QUANTITY_OPTIONS = [1, 2, 4, 8];
export const SCROLL_THRESHOLD = 120; // pixels from bottom to auto-scroll
